export default {
	"DeFi Binance" : "DeFi Binance",
	"流动性挖矿" : "流動性挖礦",
	"加入节点， 开始挖矿" : "加入節點， 開始挖礦",
	"参 与" : "參 與",
	"矿池数据" : "礦池數據",
	"总产量" : "總產量",
	"有效节点" : "有效節點",
	"参与者" : "參與者",
	"用户收入" : "用戶收入",
	"挖矿榜单" : "挖礦榜單",
	"流动性挖矿收入" : "流動性挖礦收入",
	"输出记录" : "輸出記錄",
	"地址" : "地址",
	"数量" : "數量",
	"帮助中心" : "幫助中心",
	"希望它可以帮助你" : "希望它可以幫助你",
	"安全保障" : "安全保障",
	"我们有安全的审计报告" : "我們有安全的審計報告",
	"伙伴" : "夥伴",
	"我们的商业伙伴" : "我們的商業夥伴",
	"首页" : "首頁",
	"我的矿池" : "我的礦池",
	"提取" : "提取",
	"账户" : "帳戶",
	"总挖矿金额" : "總挖礦金額",
	"可更换" : "可更換",
	"收益率" : "殖利率",
	"币池名称" : "幣池名稱",
	"最低金额" : "最低金額",
	"收益率/24小时" : "收益率/24小時",
	"挖矿记录" : "挖礦記錄",
	"金额" : "金額",
	"描述" : "描述",
	"时间" : "時間",
	"已参与" : "已參與",
	"质 押" : "質 押",
	"已质押" : "已質押",
	"记录" : "記錄",
	"兑换" : "兌換",
	"从" : "從",
	"全部" : "全部",
	"至" : "至",
	"价格" : "價格",
	"确认" : "確認",
	"矿池收益" : "礦池收益",
	"今日收益" : "今日收益",
	"普通矿池" : "普通礦池",
	"高级矿池" : "高級礦池",
	"全部的" : "全部的",
	"可用的" : "可用的",
	"申请加入" : "申請加入",
	"推荐朋友" : "推薦朋友",
	"一起赚取加密货币" : "一起賺取加密貨幣",
	"查看详情" : "看詳情",
	"团队" : "團隊",
	"推荐" : "推薦",
	"团队规模" : "團隊規模",
	"直接发起人" : "直接發起人",
	"总收入" : "總收入",
	"今天的收入" : "今天的收入",
	"我的推荐链接" : "我的推薦連結",
	"复制" : "複製",
	"1. 获取链接" : "1. 獲取連結",
	"2. 邀请朋友" : "2. 邀請朋友",
	"3. 赚取加密货币" : "3. 賺取加密貨幣",
	"等级" : "等級",
	"1 级" : "1 級",
	"2 级" : "2 級",
	"3 级" : "3 級",
	"用户地址" : "使用者位址",
	"币种" : "幣種",
	"说明" : "說明",
	"状态" : "狀態",
	"定时收益" : "定時收益",
	"今日预收益" : "今日預收益",
	"累计收益" : "累計收益",
	"将矿池收益的BNB兑换成USDT后立即到账" : "將礦池收益兌換成USDT後立即到賬",
	"将USDT提取后会在24小时内到达你的钱包" : "將USDT提取後會在24小時內到達你的錢包",
	"天" : "天",
	"高级矿池收益" : "高級礦池收益",
	"质押收益" : "質押收益",
	"下次收益" : "下次收益",
	"当前收益率" : "當前殖利率",
	"昨日收益" : "昨日收益",
	"普通矿池收益率" : "普通礦池殖利率",
	"高级矿池收益率" : "高級礦池殖利率",
	"高级矿池限时开放" : "高級礦池限時開放",
	"公告":"公告",
	"我知道了":"我知道了"
};